import { NavLink, Outlet, useNavigate } from "react-router-dom";

import Layout from "../layout";

export function SettingsPage() {
	const navigate = useNavigate();

	return (
		<Layout>
			<div className="mt-3">
				<div className="d-flex align-items-center gap-2 mb-4">
					<button
						type="button"
						className="btn btn-link p-0 text-decoration-none fs-4 fw-bold text-dark"
						onClick={() => navigate(-1)}
					>
						&#8249;
					</button>
					<h2 className="m-0">Configuración</h2>
				</div>

				<ul className="nav nav-tabs mb-4">
					<li className="nav-item">
						<NavLink
							to="printer"
							className={({ isActive }) =>
								isActive ? "nav-link active" : "nav-link"
							}
						>
							Impresora
						</NavLink>
					</li>
				</ul>

				<Outlet />
			</div>
		</Layout>
	);
}
